var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataList',{attrs:{"title":"Стадії воронки продажів","resource":"crm-sales-funnel-stages","columns":_vm.columns,"get-items-fn":_vm.getTypes}})}
var staticRenderFns = []

export { render, staticRenderFns }